import { css, LitElement, html } from 'lit';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';

var css_248z = css`svg{max-height:160px;max-width:160px}`;

/**
 * @prop {string} svg Icon svg that is imported from the `sc-aab-icon-set`
 * @prop {number} size Attribute indicating the size of the icon which has a range from 1 to 20,
 * each increment adds 8px to the height and width which means that your icon can have a maximum
 * of 160px by 160px
 * @prop {string} color Attribute indicating the svg path fill color of the icon which should only
 * be filled with a color from the
 * [color library](https://aabdesignsystemtsa.z6.web.core.windows.net/foundation/colour/#styles)
 * @prop {string} label Attribute indicating the label of the icon (for accessibility)
 * @tagname aab-icon
 */
class AabIcon extends LitElement {
  constructor() {
    super();
    this.svg = '';
    this.size = 5;
  }

  static get properties() {
    return {
      svg: { type: String },
      size: { type: Number },
      color: { type: String },
      label: { type: String },
    };
  }

  static get styles() {
    return [css_248z];
  }

  updated() {
    const svgElement = this.shadowRoot.querySelector('svg');

    if (svgElement) {
      const calculatedSize = this.size * 8;
      svgElement.style.width = `${calculatedSize}px`;
      svgElement.style.height = `${calculatedSize}px`;
      svgElement.style.display = 'inherit';

      if (this.color) {
        // Colouring all paths in SVGs is currently not feasible. We've rolled back this change due to
        // issues with icons having overlapping/multiple paths, which first require proper replacement.
        const svgPathElement = svgElement.querySelector('path');
        svgPathElement.style.fill = this.color;
      }

      if (this.label) {
        const title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
        title.textContent = this.label;
        svgElement.prepend(title);
      }
    }
  }

  render() {
    return html`${unsafeSVG(this.svg)}`;
  }
}

export { AabIcon as default };
